import { Component } from '@angular/core';

@Component({
  templateUrl: './disclaimer-policy.component.html',
  styleUrl: './disclaimer-policy.component.css'
})
export class DisclaimerPolicyComponent {

}
